export const firebaseConfig = {
  apiKey: "AIzaSyDTNF6V906Ts4x5B81H8j7CCrw3LORTMvs",
  authDomain: "dhibot-1698217291927.firebaseapp.com",
  projectId: "dhibot-1698217291927",
  storageBucket: "dhibot-1698217291927.appspot.com",
  messagingSenderId: "930465213073",
  appId: "1:930465213073:web:f2f0afa6441fe70e932d30",
  measurementId: "G-FEMCTHGL1W"
};
